import { Box, ChevronLink } from '@telus-uds/components-web'
import palette from '@telus-uds/palette-allium'
import { useMedia } from 'react-use'
import { utils } from '@digital-commerce/shared-utils'
import useTranslate from '../../../hooks/useTranslate'
import useFeatureFlags from '../../../hooks/useFeatureFlags'
import useCart from '../../../hooks/useCart'
import useAuthentication from '../../../hooks/useAuthentication'
import { Container } from './styles'
import PAPMessage from '../PAPMessage'

const { isBusinessCart, isMobilityEppCart, isManageChannelFlow } = utils.cart

const PriceSummaryBottomActions = () => {
  const translate = useTranslate()
  const isAuthenticated = useAuthentication()
  const { data: featureFlags } = useFeatureFlags()
  const { cart } = useCart()
  const isMobile = useMedia('(max-width: 767px)')

  const getUrl = () => {
    const isNewCustomer = !isAuthenticated
    const isBusinessFlow = isBusinessCart(cart)
    const isMobilityEppFlow = isMobilityEppCart(cart)
    const isOptikManageChannel = isManageChannelFlow(cart)
    if (isMobilityEppFlow) {
      return '/mobility/phones?linktype=commerce_continueshopping'
    }
    if (isNewCustomer) {
      return isBusinessFlow
        ? '/business/small?linktype=commerce_continueshopping'
        : '/?linktype=commerce_continueshopping'
    }
    if (isOptikManageChannel) {
      return '/my-telus?linktype=commerce_continueshopping'
    }
    return '/my-account?linktype=commerce_continueshopping'
  }

  return (
    <Box vertical={2}>
      <Container>
        {featureFlags?.papMessage && !isMobile && <PAPMessage isInPriceSummary />}
        <ChevronLink
          href={getUrl()}
          direction="left"
          testID="continue-shopping"
          tokens={{ color: palette.color.purpleTelus }}
        >
          {translate('priceSummary.continueShopping.label')}
        </ChevronLink>
      </Container>
    </Box>
  )
}

export default PriceSummaryBottomActions
